import { settings } from "imagica-corekit/dist/base/kernel/Settings";

export function CloseIcon() {
  return <img src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`} data-testid="CloseIcon" />;
}
